// @flow
import * as React from 'react'
import Link from 'next/link'
import classnames from 'classnames'

import { useIconStyles } from './styles'

type IconProps = {
  icon: string,
  href?: string,
  size?: 'xs' | 's' | 'm' | 'l' | 'xl',
  color?: 'primary' | 'warning' | 'danger',
  className?: string,
  rounded?: boolean,
  badge?: boolean,
  isDisabled?: boolean,
  onClick?: (e: SyntheticEvent<HTMLElement>) => void
}

const Icon = ({
  icon,
  rounded,
  badge,
  size = 's',
  color = 'primary',
  className,
  isDisabled,
  href,
  onClick,
  ...props
}: IconProps) => {
  const classes = useIconStyles()

  const Icon = (
    <i
      className={classnames(
        'icon',
        `icon-${size}`,
        classes.iconWrapper,
        `color-${color}`,
        {
          rounded,
          badge,
          disabled: isDisabled,
          clickable: typeof href === 'string' || typeof onClick === 'function'
        },
        className
      )}
      onClick={onClick}
      {...props}
    >
      {icon}
    </i>
  )

  return href ? <Link href={href}>{Icon}</Link> : Icon
}

export default Icon
